module.exports = __webpack_public_path__ + "img/carousel.30b01b13.svg";